import { useEffect, useRef, type ReactNode } from 'react';

/** Native modal semantics keep keyboard focus inside an overlaid editor. */
export function DetailPanel({ open = true, label, className = '', onClose, children }: {
  open?: boolean; label: string; className?: string; onClose: () => void; children: ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (!open) return;
    const trigger = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const dialog = ref.current;
    if (dialog?.showModal) dialog.showModal(); else dialog?.setAttribute('open', '');
    return () => { if (trigger?.isConnected) trigger.focus(); };
  }, [open]);
  if (!open) return <section className="customer-create">{children}</section>;
  return <dialog ref={ref} className="detail-panel-modal" aria-label={label} onCancel={event => { event.preventDefault(); onClose(); }}>
    <section className={`drawer workspace-drawer ${className}`}>{children}</section>
  </dialog>;
}
